import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const SettingsComponent = lazy(() => import('./settings.tsx'));

export const settingsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <SettingsComponent />
      </Suspense>
    )
  }
];
